// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"18be5325","538":"889d5b80"}[chunkId] + ".chunk.js";
};